import * as React from 'react';
import { ContentWidget } from '../../../widgets/ContentWidget';
import { PageWidget } from '../../../widgets/layout/PageWidget';

export interface SharedLegalPageOptions {
  label: string;
  updated?: string;
}

export const SharedLegalPage: React.FC<React.PropsWithChildren<SharedLegalPageOptions>> = (props) => {
  return (
    <PageWidget title={props.label}>
      <ContentWidget>
        <h1>{props.label}</h1>
        {props.updated ? <h3>Last updated: {props.updated}</h3> : null}
        {props.children}
      </ContentWidget>
    </PageWidget>
  );
};
